/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as StartProRouteImport } from './routes/start-pro'
import { Route as StartRouteImport } from './routes/start'
import { Route as DziekujemyRouteImport } from './routes/dziekujemy'
import { Route as CennikRouteImport } from './routes/cennik'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PodgladSlugRouteImport } from './routes/podglad.$slug'

const StartProRoute = StartProRouteImport.update({
  id: '/start-pro',
  path: '/start-pro',
  getParentRoute: () => rootRouteImport,
} as any)
const StartRoute = StartRouteImport.update({
  id: '/start',
  path: '/start',
  getParentRoute: () => rootRouteImport,
} as any)
const DziekujemyRoute = DziekujemyRouteImport.update({
  id: '/dziekujemy',
  path: '/dziekujemy',
  getParentRoute: () => rootRouteImport,
} as any)
const CennikRoute = CennikRouteImport.update({
  id: '/cennik',
  path: '/cennik',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PodgladSlugRoute = PodgladSlugRouteImport.update({
  id: '/podglad/$slug',
  path: '/podglad/$slug',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/cennik': typeof CennikRoute
  '/dziekujemy': typeof DziekujemyRoute
  '/start': typeof StartRoute
  '/start-pro': typeof StartProRoute
  '/podglad/$slug': typeof PodgladSlugRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/cennik': typeof CennikRoute
  '/dziekujemy': typeof DziekujemyRoute
  '/start': typeof StartRoute
  '/start-pro': typeof StartProRoute
  '/podglad/$slug': typeof PodgladSlugRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/cennik': typeof CennikRoute
  '/dziekujemy': typeof DziekujemyRoute
  '/start': typeof StartRoute
  '/start-pro': typeof StartProRoute
  '/podglad/$slug': typeof PodgladSlugRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/cennik'
    | '/dziekujemy'
    | '/start'
    | '/start-pro'
    | '/podglad/$slug'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/cennik'
    | '/dziekujemy'
    | '/start'
    | '/start-pro'
    | '/podglad/$slug'
  id:
    | '__root__'
    | '/'
    | '/cennik'
    | '/dziekujemy'
    | '/start'
    | '/start-pro'
    | '/podglad/$slug'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CennikRoute: typeof CennikRoute
  DziekujemyRoute: typeof DziekujemyRoute
  StartRoute: typeof StartRoute
  StartProRoute: typeof StartProRoute
  PodgladSlugRoute: typeof PodgladSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/start-pro': {
      id: '/start-pro'
      path: '/start-pro'
      fullPath: '/start-pro'
      preLoaderRoute: typeof StartProRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/start': {
      id: '/start'
      path: '/start'
      fullPath: '/start'
      preLoaderRoute: typeof StartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dziekujemy': {
      id: '/dziekujemy'
      path: '/dziekujemy'
      fullPath: '/dziekujemy'
      preLoaderRoute: typeof DziekujemyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cennik': {
      id: '/cennik'
      path: '/cennik'
      fullPath: '/cennik'
      preLoaderRoute: typeof CennikRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/podglad/$slug': {
      id: '/podglad/$slug'
      path: '/podglad/$slug'
      fullPath: '/podglad/$slug'
      preLoaderRoute: typeof PodgladSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CennikRoute: CennikRoute,
  DziekujemyRoute: DziekujemyRoute,
  StartRoute: StartRoute,
  StartProRoute: StartProRoute,
  PodgladSlugRoute: PodgladSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
